<template>
  <div class="collapsible-group" :class="{ collapsed }">
    <div class="flex items-center pb-0 text-lg font-semibold cursor-pointer select-none collapsible-group-header color-gray-900">
      <slot name="title" :collapsed="collapsed" />
      <span class="flex-grow" data-testid="collapsible-header-title" @click.prevent.stop="collapsed = !collapsed">{{ title }}</span>
      <ChevronDownIcon class="w-5 h-5 down transition duration-200" :class="{ collapsed }" @click.prevent.stop="collapsed = !collapsed" />
    </div>
    <div class="pl-6 collapsible-content" data-testid="collapsible-content"><slot /></div>
  </div>
</template>

<script lang="ts" setup>
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/vue/24/outline'

defineProps({
  title: {
    type: String,
    required: true,
  },
})

const collapsed: Ref<boolean> = ref(false)
</script>

<style lang="stylus" scoped>
.collapsible-group
  &.collapsed
    .collapsible-group-header
      svg
        transform scale(-1)

    .collapsible-content
        height 0
        overflow hidden
</style>
